import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import styles from './AboutYourself.module.css';
import SignupLayout from '../SignupLayout/SignupLayout';
import { updateCompanyProfileDetails } from '../../../redux/actions';
import { alertNotification } from '../../../components/TopNotification/alertNotification';

const AboutYourself = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const userProfile = useSelector((state) => state.profileReducer.user.profile);
  const loadingAbout = useSelector(
    (state) => state.getCompanyDetailsReducer.loadingAbout
  );

  const [firstName, setFirstName] = useState(userProfile?.FirstName || '');
  const [lastName, setLastName] = useState(userProfile?.LastName || '');
  const [howHeardAbout, setHowHeardAbout] = useState(userProfile?.HowYouHeardAbout || '');
  const [currentATS, setCurrentATS] = useState(userProfile?.YourCurrentATS || '');

  const nextHandler = () => {
    if (loadingAbout) return;

    if (!firstName.trim()) {
      alertNotification('error', 'Please enter first name');
      return;
    }
    if (!lastName.trim()) {
      alertNotification('error', 'Please enter last name');
      return;
    }

    const onApiSuccess = () => {
      history.push('/about-your-company');
    };

    const payload = {
      FirstName: firstName.trim(),
      LastName: lastName.trim(),
      HowHeardAbout: howHeardAbout.trim(),
      YourCurrentATS: currentATS.trim(),
      AccountTypeCode: 'EMP',
      Source: 'skillradar',
      WizardFlow: 601,
      onSuccess: onApiSuccess,
      onError: () => {},
    };

    dispatch(updateCompanyProfileDetails(payload));
  };

  const isNextDisabled =
    !firstName.trim() || !lastName.trim() || !howHeardAbout.trim() || !currentATS.trim() || loadingAbout;

  return (
    <SignupLayout
      step={0.1}
      totalSegments={3}
      heading="Welcome to Skillgigs!"
      subHeading="Let's set up your profile"
      onNext={nextHandler}
      isNextDisabled={isNextDisabled}
      showBack={false}
      nextLoading={loadingAbout}
      nextButtonText="Next"
    >
      <div className={styles.nameRow}>
        <div className={styles.inputGroup}>
          <label className={styles.label}>
            First Name<span>*</span>
          </label>
          <input
            type="text"
            className={styles.input}
            placeholder="Enter first name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
            disabled={loadingAbout}
          />
        </div>

        <div className={styles.inputGroup}>
          <label className={styles.label}>
            Last Name<span>*</span>
          </label>
          <input
            type="text"
            className={styles.input}
            placeholder="Enter last name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
            disabled={loadingAbout}
          />
        </div>
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.label}>
          How You Heard About Skillgigs<span>*</span>
        </label>
        <input
          type="text"
          className={styles.input}
          placeholder="E.g Google, LinkedIn..."
          value={howHeardAbout}
          onChange={(e) => setHowHeardAbout(e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
          disabled={loadingAbout}
        />
      </div>

      <div className={styles.inputGroup}>
        <label className={styles.label}>
          Your Current ATS<span>*</span>
        </label>
        <input
          type="text"
          className={styles.input}
          placeholder="Enter current ATS"
          value={currentATS}
          onChange={(e) => setCurrentATS(e.target.value.replace(/[^a-zA-Z\s]/g, ''))}
          disabled={loadingAbout}
        />
      </div>
    </SignupLayout>
  );
};

export default AboutYourself;
